<template>
  <section class="modal-address" @click.self="$emit('closeModal')">
    <button>
      <deleteIcon />
    </button>
    <div class="content">
      <div
        class="in-address"
        v-for="(address, index) in addresses"
        :key="address.id"
        @click="
          (e) => {
            addressSelect(e, index);
          }
        "
      >
        <cart-address-item
          :address="address"
          :selectedAddress="selectedAddress"
          :index="index"
          @delete-address="deleteAddress"
          @edit-address="editAddress"
          :disabled="disabled"
          class="box-address"
        >
        </cart-address-item>
      </div>
    </div>
  </section>
</template>
<script>
import CartAddressItem from "@/parts/Front/components/cart/CartAddressItem";
// import deleteIcon from "../../components/Icon/deleteIcon.vue";
import deleteIcon from "@/components/svgs/CloseSvg";
export default {
  name: "",
  inject: ["mediaQueries"],
  components: {
    CartAddressItem,
    deleteIcon,
  },
  data() {
    return {
      disabled: false,
    };
  },
  props: {
    addresses: Array,
    selectedAddress: Object,
  },

  methods: {
    addressSelect(e, index) {
      if (!this.$root.hasClass(e.target, "not-in-address")) {
        // this.selectedAddress = this.addresses[index];
        this.$emit("addressSelect", this.addresses[index]);
      }
    },
    deleteAddress(id) {
      this.$emit("delete-address", id);
    },
    editAddress(address) {
      this.$emit("edit-address", address);
    },
  },
};
</script>
<style scoped>
.modal-address {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: #00000062;
  backdrop-filter: blur(5px);
  z-index: 999;
  display: grid;
  place-items: center;
}
.content {
  width: 900px;
  max-height: 70vh;
  overflow: auto;
  padding: 1rem;
  background: #fff;
  border-radius: 12px;
}
.box-address {
  display: block !important;
  width: 100% !important;
  background-color: var(--color-eai);
  border: none !important;
  border-radius: 15px;
  margin-right: 0 !important;
}
@media only screen and (max-width: 1024px) {
  .content {
    width: 90%;
  }
}
@media only screen and (max-width: 768px) {
  .content {
    width: 95%;
  }
}
</style>
